import { PropsWithChildren } from "react";
import classes from "./Wrapper.module.css";
import Logo from "../../assets/logo.png";

const Wrapper: React.FC<PropsWithChildren> = (props) => {
  return (
    <div className={classes.table}>
      <div className={classes.cell}>
        <div className={classes.container}>
          <div className={classes.logo}>
            <img
              src={Logo}
              className="img-responsive"
              alt="ToDoo"
              title="ToDoo"
            />
          </div>
          {props.children}
        </div>
      </div>
    </div>
  );
};

export default Wrapper;
